// Porta leve para `src/app` e `src/routes` (JS inicial): manifesto, catálogo e o carregador da tela.
export { WALLET_DASHBOARD_PATH, walletDashboardScreen } from './wallet-dashboard.screen';
export { loadWalletDashboardMessages } from './wallet-dashboard.catalog';

/** A tela da rota (`WalletDashboardRouteScreen`), por `lazyScreen`. */
export const loadWalletDashboardScreens = () => import('./wallet-dashboard.page');

/** O guia da tela para o Luy (U46), sob demanda. */
export const loadWalletDashboardGuides = () => import('./wallet-dashboard.guide');
